<!-- new Component: 바우처 수량 선택, ASB-12562 추가(modified) from myCouponDTL.vue -->

<template>
  <div class="voucher_contact voucher_contact--evoucher">
    <p>{{ text }}하실 바우처의 총 수량을 선택해주세요.</p>

    <div class="evoucher_cnt">
      <dl>
        <dt>
          수량선택
          <p>(보유 : <span>{{ totalCouponSum }}</span>장)</p>
        </dt>
        <dd>
          <!-- Default: 보유 수량이 있는 경우 -> 감소 disabled -->
          <!-- 보유수량 > 선택 수량 둘다 오픈 -->
          <!-- 보유수량 = 선택 수량 -> 증가 disabled -->
          <div class="cnt_box">
            <input id="cp" class="ipt_input" type="number" v-model.number="selectedCP" @change="calcCnt2()">
            <button type="button" class="btn_cnt btn_cnt_minus" @click="calcCnt('M')" v-bind:disabled="mBtnDisable">감소</button>
            <button type="button" class="btn_cnt btn_cnt_plus" @click="calcCnt('P')" v-bind:disabled="pBtnDisable">증가</button>
          </div>
        </dd>
      </dl>

      <dl>
        <dt>선택수량</dt>
        <dd>
          총 <span>{{ selectedCP }}</span> 장
        </dd>
      </dl>
    </div>

    <div class="evoucher_num">
      <dl>
        <dt>잔여 바우처 수량</dt>
        <dd>
          총 <span>{{ totalCouponSum - selectedCP }}</span> 장
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'counter',
  component: {

  },
  props: {
    text: String,
    totalCouponSum: Number
  },
  data () {
    return {
      selectedCP: 1,
      mBtnDisabled: true,
      pBtnDisabled: false
    }
  },
  computed: {
    mBtnDisable () {
      return this.mBtnDisabled
    },
    pBtnDisable () {
      return this.pBtnDisabled
    }
  },
  methods: {
    calcCnt: function (flag) {
      if (flag === 'M') {
        this.selectedCP--
      } else if (flag === 'P') {
        this.selectedCP++
      }
      this.calcCnt2()
    },
    calcCnt2: function () {
      if (this.selectedCP > 1 && this.selectedCP < this.totalCouponSum) {
        this.mBtnDisabled = false
        this.pBtnDisabled = false
      }
      if (this.selectedCP >= this.totalCouponSum) {
        this.pBtnDisabled = true
        this.mBtnDisabled = false
        this.selectedCP = this.totalCouponSum
      }
      if (this.selectedCP <= 1) {
        this.mBtnDisabled = true
        this.pBtnDisabled = false
        this.selectedCP = 1
      }
      // console.log(this.selectedCP + '  ' + this.totalCouponSum)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/concierge/component/counter.vue